import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { P } from 'shared';
function DisclosureFooter({ termLength, loanAmount, calculatedApr, promotionalPeriod, }) {
    const formattedLoanAmount = loanAmount
        ? `$${Number(loanAmount).toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })}`
        : '';
    return (_jsxs("div", { className: "disclosure-footer w100", children: [_jsx("hr", { className: "flex-finalize-divider" }), promotionalPeriod && (_jsxs(P, { variant: "body-small", className: "color-gray mar-t-8 w100", children: [_jsx("sub", { children: "\u2020" }), "Based on a ", promotionalPeriod, " month deferred finance charge promotional period."] })), _jsxs(P, { variant: "body-small", className: "color-gray mar-t-8 w100", children: [_jsx("sub", { children: "^" }), "Based on a ", termLength, "-month ", formattedLoanAmount, ' ', "transaction at ", calculatedApr, "% APR."] })] }));
}
export default DisclosureFooter;
